import { Address, beginCell, fromNano, toNano } from '@ton/ton';
//////////////////////////////////////////////////////
import { client } from '@/core/utils';
import { SendTransactionRequest } from '@tonconnect/ui-react';

const getNativeBalance = async (wallet: string) => {
	const tonBalanceValue = await client.getBalance(Address.parse(wallet));
	const nativeBalance = parseFloat(fromNano(tonBalanceValue));
	if (nativeBalance === 0.0) {
		return { balance: "0" };
	}
	return {
		balance: parseFloat(fromNano(tonBalanceValue)).toFixed(4),
	};
};

const getJettonWalletAddress = async (
	jettonMasterAddress: string,
	userWalletAddress: string
) => {
	const userJettonWalletAddress = await client.runMethod(
		Address.parse(jettonMasterAddress),
		'get_wallet_address',
		[
			{
				type: 'slice',
				cell: beginCell()
					.storeAddress(Address.parse(userWalletAddress))
					.endCell(),
			},
		]
	);
	return {
		jettonWalletAddress: userJettonWalletAddress.stack
			.readAddress()
			.toString(),
	};
};

const getJettonBalance = async (userJettonWalletAddress: string) => {
	const response = await client.runMethod(
		Address.parse(userJettonWalletAddress),
		'get_wallet_data',
		[]
	);
	//TODO get decimals from token call
	const responseParsed = Number(response.stack.readBigNumber()) / 1000000;
	//TODO watch out, maybe lose precission using float
	return {
		jettonBalance: parseFloat(responseParsed.toString()).toFixed(4),
	};
};

const getTransferJettonTxBody = (
	txMessage: string,
	amountToPay: string,
	toAddr: string,
	fromAddr: string,
	fromJettonWalletAddr: string
): SendTransactionRequest => {
	const forwardPayload = beginCell()
		.storeUint(0, 32) // 0 opcode means we have a comment
		.storeStringTail(txMessage)
		.endCell();
	const body = beginCell()
		.storeUint(0xf8a7ea5, 32) // opcode for jetton transfer
		.storeUint(0, 64) // query id
		.storeCoins(toNano(amountToPay)) // Jetton amount for transfer (decimals = 6 - USDT, 9 - default). Function toNano use decimals = 9 (remember it)
		.storeAddress(
			//Address.parse(andresinJettonWalletAddrTestnet)
			Address.parse(toAddr)
		) // destination:MsgAddress
		//this address is to return fees not used in the process
		.storeAddress(Address.parse(fromAddr)) // response_destination:MsgAddress
		.storeUint(0, 1) // no custom payload
		//TODO review how many nanotons send as payloadforward
		.storeCoins(toNano('0.01')) // forward amount (if >0, will send notification message)
		.storeBit(1) // we store forwardPayload as a reference
		.storeRef(forwardPayload)
		.endCell();
	return {
		validUntil: Math.floor(Date.now() / 1000) + 360,
		messages: [
			{
				//TODO vigilar tmb el amount, ha de ser mas grande que .storeCoins(toNano('0.02')) del body
				address: fromJettonWalletAddr, // sender address
				//TODO review how many nanotons send as tx fees
				amount: toNano('0.06').toString(), //Toncoin in nanotons
				//payload: internalTx.body.toBoc().toString('base64'),
				payload: body.toBoc().toString('base64'),
			},
		],
	};
};

export const TonService = {
	getNativeBalance,
	getJettonWalletAddress,
	getJettonBalance,
	getTransferJettonTxBody,
};
